export const SUGGESTED_ANNOTATIONS_ORIGIN = {
  anyword: 'anyword',
} as const;
export type SuggestedAnnotationsOrigin =
  (typeof SUGGESTED_ANNOTATIONS_ORIGIN)[keyof typeof SUGGESTED_ANNOTATIONS_ORIGIN];

export const USER_ANNOTATIONS_ORIGIN = 'user';

const SUGGESTED_ANNOTATIONS_ORIGIN_PROPS = {
  [SUGGESTED_ANNOTATIONS_ORIGIN.anyword]: {
    label: "Anyword's data",
  },
};

export const getSuggestedAnnotationsOriginLabel = (origin: SuggestedAnnotationsOrigin): string =>
  SUGGESTED_ANNOTATIONS_ORIGIN_PROPS[origin]?.label;
